'use client';

import { TBlogCategoryItemized } from '@/app/(blogposts)/blog/blog.types';
import { Text } from '@/components/ui/Text';
import classNames from 'classnames';
import Link from 'next/link';
import { useCallback, useState } from 'react';
import { BlogHeaderMoreTopicsItem } from '../BlogHeaderMoreTopicsItem';
import { BlogHeaderSearchIcon } from '../BlogHeaderSearchIcon';
import { useBlogHeaderSearch } from '../useBlogHeaderSearch';

import './BlogHeaderDesktop.scss';

enum Mode {
  Resting = 'rest',
  Searching = 'search',
}

type Props = {
  categories: TBlogCategoryItemized[];
  className?: string;
  title: string;
};

export const BlogHeaderDesktop: React.FC<Props> = ({ title, categories }) => {
  const { searchTerm } = useBlogHeaderSearch();
  const [mode, setMode] = useState(searchTerm ? Mode.Searching : Mode.Resting);

  const handleSearchIconClick = useCallback(() => {
    if (mode === Mode.Resting) {
      setMode(Mode.Searching);

      return;
    }

    setMode(Mode.Resting);
  }, [mode]);

  return (
    <>
      <div
        className={classNames('BlogHeaderDesktop', {
          'BlogHeaderDesktop--resting': mode === Mode.Resting,
          'BlogHeaderDesktop--searching': mode === Mode.Searching,
        })}
      >
        <div
          className={classNames(
            'BlogHeaderDesktop__title',
            {
              hidden: mode === Mode.Searching,
            },
            'flex-column flex items-center'
          )}
        >
          <Link href='/blog'>
            <Text variant='h3-serif'>{title}</Text>
          </Link>
        </div>

        <div className='BlogHeaderDesktop__options'>
          {mode === Mode.Resting && (
            <BlogHeaderMoreTopicsItem
              className='BlogHeaderDesktop__more-topics'
              content={categories}
            />
          )}

          <BlogHeaderSearchIcon
            isSearching={mode === Mode.Searching}
            onClick={handleSearchIconClick}
            searchTerm={searchTerm}
          />
        </div>
      </div>

      <hr className='BlogHeaderDesktop__divider' />
    </>
  );
};
